// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import {MenuItem, DropdownButton} from 'ui'

export const getUserName = (user) => {
  return user?.name || user?.email
}

function UserDropdown(props) {
  const menuItems = props.users.map((user, index) => {
    return (
      <MenuItem
        eventKey={`user-${index}`}
        onClick={(event)=>{props.onSelect(user.id)}}
        key={`user-${index}`}
      >
        {getUserName(user)}
      </MenuItem>
    )
  })

  const user = props.user;
  const name = getUserName(user);
  const title = name ? name : 'Select User';

  return (<DropdownButton
    title={`Coded By: ${title}`}
    id={`user-dropdown`}
    variant='white'>
      <MenuItem header>
        Coded By
      </MenuItem>
      {menuItems}
    </DropdownButton>)
}

export default UserDropdown;
